import { useEffect, useState } from 'react';
import { TypeOfTags } from '../../../modules-modal/private-template-modules-modal/model/types';
import { ITagsGroup } from '../../../../entities/template/private-template-tag-group/template-tag-group/api/types';
import { templateTagGroupApi } from '../../../../entities/template/private-template-tag-group';
import { privateTemplateTagAPI } from '../../../../entities/template/private-template-tag';
import { IGetTemplateTagGroupsResponse } from '../../../../entities/template/private-template-tag-group/model/types/types';
import { TagGroupType } from '../../../../entities/template/private-template-tag-group/model/types';

export const useTemplateTagGroupsData = (typeOfTags: TypeOfTags, debouncedSearch: string) => {
	const [groupTags, setGroupTags] = useState<ITagsGroup[]>([]);

	const {
		isLoading: isLoadingWithoutGroupTags,
		data: tagsWithoutGroups,
		refetch: refetchTagsWithoutGroups,
	} = privateTemplateTagAPI.useGetTagsWithoutGroupsQuery({
		limit: 127,
		page: 1,
	});

	const {
		isLoading: isLoadingWithoutTags,
		data: tagGroupsData,
		refetch: refetchTagGroups,
	} = templateTagGroupApi.useGetTemplateGroupsQuery({
		page: 1,
		limit: 127,
		search: debouncedSearch,
	});

	const isLoading = isLoadingWithoutTags || isLoadingWithoutTags;

	useEffect(() => {
		if (!isLoading) {
			let updatedGroupTags: ITagsGroup[] = [];
			const privateData = tagGroupsData as IGetTemplateTagGroupsResponse;
			updatedGroupTags = privateData?.groupTags || [];

			setGroupTags([
				{
					id: TagGroupType.tagsWithoutGroup,
					name: 'Без группы',
					tags: tagsWithoutGroups?.templateTags || [],
				},
				...updatedGroupTags,
			]);
		}
	}, [isLoading, tagGroupsData, tagsWithoutGroups, typeOfTags]);

	return {
		isLoading,
		groupTags,
		refetchTagGroups,
		refetchTagsWithoutGroups,
		tagsWithoutGroups,
	};
};
